"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEventListener = void 0;
function addEventListener(target, eventType, callback) {
    if (target.addEventListener) {
        target.addEventListener(eventType, callback, true);
        return function remove() {
            target.removeEventListener(eventType, callback, true);
        };
    }
    return null;
}
exports.addEventListener = addEventListener;
//# sourceMappingURL=addEventListener.js.map